import logo from './logo_with_name.png';
import about from './about.webp';
import banner1 from './banner1.webp';
import faq from './faq.jpg';
import mission from './mission.jpg';
import service from './services.jpg';
import vision from './vision.jpg'; 
import welcome from './welcom.mp4'; 
import whatwedo from './whatwedo.jpg';
import world from './world.jpg';
import music from './taj-mahal-music.mp3';

const assets ={
logo,
about,
banner1,
faq,
mission,
service,
vision,
welcome,
whatwedo,
world,
music,
};

export default assets;